export const browserHasScrollbar = (): boolean => (
  window && document && document.documentElement
    ? window.innerWidth - document.documentElement.clientWidth > 0
    : false
);
